import { useTown } from "@/hooks/use-town";
import { LocationControl } from "@/components/LocationPicker";
export const ALL_TOWNS = "All Towns";
/** Route-specific browse controls use the same postcode/area picker as the header. */
export function TownPicker({ value, onChange, className }: { value: string; onChange: (town: string) => void; ariaLabel?: string; className?: string }) {
  const { selectedTown, locationLabel, openLocationPicker } = useTown();
  return <LocationControl label={value === selectedTown ? locationLabel : value === ALL_TOWNS ? "All Ayrshire" : value} onClick={() => openLocationPicker(onChange)} className={className} />;
}
